import "./App.css";
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import React, { useState } from "react";
import Login from "./Components/Login";
import Home from "./Components/Home";
import ProductView from "./Components/ProductView";
import Dummy from "./Components/Dummy";
import ProductPage from "./Components/ProductPage";
import Fashion from "./Components/ProductsList/Fashion";
import Mobile from "./Components/ProductsList/Mobile";
import Grocery from "./Components/ProductsList/Grocery";
import AllGrocery from "./Components/ProductsList/AllGrocery";
import AllFashion from "./Components/ProductsList/AllFashion";
import BuyNow from "./Components/BuyNow";
import Cart from "./Components/Cart";
import Curosel from "./Components/Curosel";
import HomeNav from "./Components/HomeNav";
import Television from "./Components/ProductsList/Television";
import HomeAppliances from "./Components/ProductsList/HomeAppliances";
import Footer from "./Components/Footer";
import AllMobile from "./Components/ProductsList/AllMobile";
import AllTelevision from "./Components/ProductsList/AllTelevision";
import AllHomeAppliances from "./Components/ProductsList/AllHomeAppliances";
import ScrollToTop from "./Components/ScrollToTop";

function App() {
  const [navChange, setNavChange] = useState({
    navbar: false,
    navbarText: "",
  });

  function refreshPage() {
    window.location.reload();
  }

  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <nav className="navs-bar">
          <Link to="/Home" className="navs-brand">
            Shop.in
          </Link>
          <ul>
            <li>
              {navChange.navbar ? (
                <Link className="navs-link navs-name">
                  Welcome <b>{navChange.navbarText}</b>
                </Link>
              ) : null}
            </li>
            <li>
              {navChange.navbar ? (
                <Link to="/Cart" className="navs-link">
                  Cart
                </Link>
              ) : null}
            </li>
            <li>
              {navChange.navbar ? (
                <Link to="/Home" onClick={refreshPage} className="navs-link">
                  Logout
                </Link>
              ) : (
                <Link to="/" className="navs-link">
                  Login
                </Link>
              )}
            </li>
          </ul>
        </nav>
        <Switch>
          <Route
            exact
            path="/"
            component={() => <Login setNavChange={setNavChange} />}
          />
          <Route path="/Home" component={Home} />

          <Route path="/Grocery" component={Grocery} />
          <Route
            path="/ProductView"
            login={setNavChange}
            component={ProductView}
          />
          <Route path="/Dummy" component={Dummy} />
          <Route path="/ProductPage" component={ProductPage} />
          <Route path="/Fashion" component={Fashion} />
          <Route path="/AllGrocery" component={AllGrocery} />
          <Route path="/Mobile" component={Mobile} />
          <Route path="/AllFashion" component={AllFashion} />
          <Route path="/Cart" component={Cart} />
          <Route path="/BuyNow" component={BuyNow} />
          <Route path="/Curosel" component={Curosel} />
          <Route path="/HomeNav" component={HomeNav} />
          <Route path="/HomeAppliances" component={HomeAppliances} />
          <Route path="/Television" component={Television} />
          <Route path="/Footer" component={Footer} />
          <Route path="/AllMobile" component={AllMobile} />
          <Route path="/AllTelevision" component={AllTelevision} />
          <Route path="/AllHomeAppliances" component={AllHomeAppliances} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
